/**
 * sessionStorage keys used to coordinate the Ping → Okta → /login-error auth flow
 * across full-page redirects.
 *
 * `PENDING_IDP_KEY` — tracks which IdP is currently being attempted (set before each
 *   redirect, cleared on success or final failure).
 *
 * `ACTIVE_IDP_KEY` — stores the configId of the IdP that successfully authenticated
 *   (used by SessionCheckerService to call the right session endpoint without relying
 *   on the OIDC library's reactive signal, which may lag behind at startup).
 */
export const PENDING_IDP_KEY = 'pendingIdp';
export const ACTIVE_IDP_KEY = 'activeIdp';
